module.exports = __webpack_public_path__ + "img/booking.com-logo.5fa69cb0.png";